// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 60 60"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M34.3599 6.57363L53.18 18.8067C53.845 19.2389 54.1775 19.4551 54.4184 19.7433C54.6316 19.9985 54.7918 20.2937 54.8896 20.6116C55 20.9707 55 21.3673 55 22.1604V40.4897C55 44.6901 55 46.7903 54.1825 48.3946C53.4635 49.8058 52.3161 50.9532 50.9049 51.6722C49.3006 52.4897 47.2004 52.4897 43 52.4897H17C12.7996 52.4897 10.6994 52.4897 9.09507 51.6722C7.68386 50.9532 6.5365 49.8058 5.81745 48.3946C5 46.7903 5 44.6901 5 40.4897V22.1604C5 21.3673 5 20.9707 5.11043 20.6116C5.20818 20.2937 5.36837 19.9985 5.58162 19.7433C5.82253 19.4551 6.15503 19.2389 6.82005 18.8067L25.6401 6.57364M34.3599 6.57363C32.7818 5.54786 31.9927 5.03498 31.1426 4.83542C30.3911 4.65903 29.6089 4.65903 28.8574 4.83542C28.0073 5.03498 27.2182 5.54786 25.6401 6.57364M34.3599 6.57363L49.8403 16.6359C51.56 17.7537 52.4198 18.3125 52.7176 19.0213C52.9778 19.6407 52.9778 20.3387 52.7176 20.9581C52.4198 21.6668 51.56 22.2257 49.8403 23.3435L42.5 28.1147M25.6401 6.57364L10.1597 16.6359C8.44003 17.7537 7.58022 18.3125 7.28243 19.0213C7.02219 19.6407 7.02219 20.3387 7.28243 20.9581C7.58022 21.6668 8.44003 22.2257 10.1597 23.3435L17.8999 28.3746M53.75 47.4897L37.1429 32.4897M22.8571 32.4897L6.25 47.4897M17.8999 28.3746L25.6401 33.4058C27.2182 34.4315 28.0073 34.9444 28.8574 35.144C29.6089 35.3204 30.3911 35.3204 31.1426 35.144C31.9927 34.9444 32.7818 34.4315 34.3599 33.4058L42.5 28.1147M17.8999 28.3746V20.9581H42.5V28.1147"
    />
  </svg>
);
const IconEnvelopeOpenOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconEnvelopeOpenOutline;
